import {useState, useEffect} from "react";
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw'
import ReactMarkdown from "react-markdown";
import rehypeHighlight from "rehype-highlight";
import "highlight.js/styles/atom-one-dark.css";

export default function Content({text}) {

    return (
        <div style={{width: "calc(100vw - 273px - 102px - 64px)"}}> <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw, rehypeHighlight]} children={text}></ReactMarkdown> </div>
    )
}
